export default __webpack_public_path__ + "static/media/team7.a2dc31c5.JPG";